import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { language } from './assets/translation/antTranslation';
import sixConfig from './sixConfig';


const translation = i18n.createInstance();

const translationBasePath = sixConfig.APP_CUSTOMER === 'PUGLIASALUTE' ?   `${window.location.origin}${sixConfig.BASENAME}` : window.location.origin

translation.use(XHR).init({
  fallbackLng: `${translationBasePath}/translation/en.json`,
  backend: {
    loadPath: `${translationBasePath}/translation/${language.slice(0, 2)}.json?t=`+ new Date().getTime(),
  },
  lng: language.slice(0, 2),
});
    
export default translation;